import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/layout.sidebar/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-toggle-handle {
  clip-path: polygon(0 0, 100% 16%, 100% 84%, 0 100%);
}`],
})
export class LayoutSidebarComponent implements OnInit {
    public isDesktopSidebarHidden: boolean = false;
    private readonly desktopSidebarStorageKey: string = 'kiera.desktopSidebarHidden';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        this.restoreDesktopSidebarPreference();
        await this.service.init();
        if (this.service.auth.allow('/access') === false) return;
        await this.service.status.toggle('navbar', true);
        await this.service.render();
        if ('serviceWorker' in navigator && window.isSecureContext) {
            navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
                console.info('KiERA offline fallback is unavailable in this browser.');
            });
        }
    }

    private restoreDesktopSidebarPreference() {
        try {
            this.isDesktopSidebarHidden = window.localStorage.getItem(this.desktopSidebarStorageKey) === 'true';
        } catch {
            this.isDesktopSidebarHidden = false;
        }
    }

    public async toggleDesktopSidebar(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();

        this.isDesktopSidebarHidden = !this.isDesktopSidebarHidden;
        try {
            window.localStorage.setItem(this.desktopSidebarStorageKey, String(this.isDesktopSidebarHidden));
        } catch {
            // Storage access can be unavailable in restricted browser contexts.
        }

        await this.service.render();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }
}
export default LayoutSidebarComponent;
